/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import { useProjectWeeklyReportId, useProjectWeeklyReportsUrl } from 'domain/shared/project';
import useProjectWeeklyReportsService from 'domain/projects/project/weeklyreports/ProjectWeeklyReportService';
import ProjectWeeklyReportForm from 'domain/projects/project/weeklyreports/update/ProjectWeeklyReportForm';

const UpdateProjectWeeklyReport = () => {
  const { update, getById, getValidationSchema } = useProjectWeeklyReportsService();
  const { getSingleEntityUrl } = useProjectWeeklyReportsUrl();
  const reportId = useProjectWeeklyReportId();

  return (
    <UpdateForm
      entityId={reportId}
      submitFormFunc={update}
      getDataFunc={() => getById(reportId)}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Weekly Report has been successfully saved.',
        redirect: getSingleEntityUrl(),
      }}
    >
      <ProjectWeeklyReportForm />
    </UpdateForm>
  );
};

export default UpdateProjectWeeklyReport;
